// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader__cV_KP","load7":"ButtonLoader_load7__3zNyC"};